import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useLocation, useNavigate, useSearchParams } from 'react-router-dom'

import { useAppDispatch, useAppSelector } from '@/core/store'
import { setPayed, setPayedTours, setSelectedTab } from '@/core/store/catalog.store'
import { setSelectedCategories } from '@/core/store/catalog.store'

import { IconAllPins, IconMustSee, IconTop112, IconTours } from '../../Ui/Icons'

const categoriesMap = [
  {
    name: 'allPins',
    // filters now replaced by filter index (see Home.page)
    //    filter: ['10', '7', '5', '3'],
    index: 0,
    icon: <IconAllPins />,
    svg: `<svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M24.1013 13.5803V7.3987C24.1013 5.33239 22.6331 4.48411 20.8496 5.50639L18.2939 6.96369C17.7392 7.27908 16.8148 7.3117 16.2384 7.01807L10.5289 4.16873C9.9525 3.88597 9.02809 3.90772 8.47345 4.2231L3.76443 6.92019C3.15541 7.2682 2.66602 8.11648 2.66602 8.80162V19.3833C2.66602 21.4496 4.13419 22.2979 5.91774 21.2756L8.47345 19.8183C9.02809 19.503 9.9525 19.4703 10.5289 19.764L13.3837 21.1941"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.48535 4.69092V18.8289"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M17.2822 7.54053L17.2822 11.4708"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.1796 16.2462C14.6292 9.87395 24.0699 9.88131 25.5121 16.2536C26.3583 19.9916 24.0331 23.1557 21.9949 25.113C20.5158 26.5405 18.1759 26.5405 16.6895 25.113C14.6586 23.1557 12.3334 19.9843 13.1796 16.2462Z"
        stroke="white"
        strokeWidth="1.5"
      />
      <path
        d="M19.3456 19.8811C20.6135 19.8811 21.6414 18.8533 21.6414 17.5853C21.6414 16.3174 20.6135 15.2896 19.3456 15.2896C18.0777 15.2896 17.0498 16.3174 17.0498 17.5853C17.0498 18.8533 18.0777 19.8811 19.3456 19.8811Z"
        stroke="white"
        strokeWidth="1.5"
      />
    </svg>`,
  },
  {
    name: 'top',
    // filters now replaced by index
    // filter: ['10', '7'],
    icon: <IconTop112 />,
    index: 1,
    svg: `<svg width="29" height="28" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.3471 4.83016L20.2654 9.2518C20.2537 9.85846 20.6388 10.6635 21.1288 11.0252L24.0221 13.2185C25.8771 14.6185 25.5738 16.3335 23.3571 17.0335L19.5888 18.2118C18.9588 18.4101 18.2938 19.0985 18.1305 19.7402L17.2321 23.1701C16.5204 25.8768 14.7471 26.1451 13.2771 23.7651L11.2237 20.4401C10.8504 19.8335 9.96375 19.3785 9.26375 19.4135L5.36712 19.6118C2.57879 19.7518 1.78544 18.1418 3.60544 16.0185L5.91542 13.3351C6.34709 12.8335 6.54541 11.9001 6.34708 11.2701L5.16881 7.5018C4.48047 5.28513 5.71712 4.06015 7.92212 4.78348L11.3638 5.91515C11.9471 6.10181 12.8221 5.97347 13.3121 5.6118L16.9055 3.0218C18.8421 1.6218 20.3937 2.43849 20.3471 4.83016Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M25.7371 25.6668L22.2021 22.1318" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.6061 16.0069C14.2568 15.9439 14.0248 15.6096 14.0878 15.2604C14.1217 15.0725 14.2375 14.9094 14.4036 14.8153L15.9161 13.9591C16.0433 13.8845 16.1883 13.8022 16.3508 13.7124C16.5196 13.6182 16.6819 13.5147 16.8377 13.4019C16.9988 13.2901 17.1351 13.1656 17.2465 13.0286C17.3632 12.8925 17.4363 12.7431 17.4656 12.5804C17.5064 12.3547 17.4687 12.1582 17.3525 11.9909C17.2417 11.8246 17.0524 11.7173 16.7847 11.6689C16.5328 11.6235 16.3229 11.6452 16.1551 11.7341C16.1401 11.742 16.1254 11.7503 16.1111 11.7589C15.876 11.9008 15.6174 12.076 15.347 12.0272C15.0119 11.9667 14.7881 11.6211 14.9763 11.3373C15.0475 11.2302 15.1291 11.1355 15.2212 11.0534C15.4599 10.8418 15.7371 10.7021 16.0528 10.6345C16.3685 10.5668 16.6891 10.5624 17.0145 10.6211C17.3662 10.6846 17.6745 10.808 17.9395 10.9913C18.2044 11.1746 18.3982 11.4074 18.5206 11.6896C18.6441 11.9666 18.6726 12.2888 18.6063 12.6562C18.5495 12.9711 18.4375 13.2463 18.2703 13.4817C18.1094 13.7128 17.9067 13.92 17.6622 14.1035C17.4186 14.2818 17.1503 14.4474 16.8571 14.6004L15.846 15.1577L17.5544 15.4661C17.8414 15.5179 18.032 15.7925 17.9802 16.0795C17.9284 16.3664 17.6538 16.5571 17.3668 16.5053L14.6061 16.0069Z" fill="white"/>
<path d="M12.5007 15.627C12.1898 15.5709 11.9832 15.2733 12.0394 14.9625L12.6753 11.4394L12.0113 11.3195C11.7737 11.2766 11.6158 11.0492 11.6587 10.8115C11.7009 10.578 11.9216 10.4246 12.1586 10.4372C12.2165 10.4402 12.2726 10.4417 12.327 10.4417C12.5069 10.4362 12.6731 10.4011 12.8256 10.3366C12.8969 10.3042 12.9656 10.2631 13.0317 10.2135C13.1814 10.1012 13.3638 10.0272 13.548 10.0605C13.8361 10.1125 14.0276 10.3883 13.9755 10.6764L13.1652 15.1657C13.109 15.4766 12.8115 15.6831 12.5007 15.627Z" fill="white"/>
<path d="M9.43327 15.0733C9.12239 15.0171 8.91586 14.7196 8.97198 14.4087L9.60794 10.8857L8.94394 10.7658C8.70629 10.7229 8.54841 10.4955 8.59131 10.2578C8.63347 10.0243 8.85422 9.87092 9.09124 9.88346C9.1491 9.88652 9.20523 9.88801 9.25965 9.88794C9.43948 9.88247 9.60568 9.84744 9.75825 9.78285C9.82947 9.75044 9.89817 9.70941 9.96435 9.65977C10.114 9.54747 10.2965 9.47353 10.4806 9.50677C10.7687 9.55879 10.9602 9.83456 10.9082 10.1227L10.0978 14.612C10.0417 14.9229 9.74415 15.1294 9.43327 15.0733Z" fill="white"/>
</svg>
`,
  },
  {
    name: 'mustSee',
    // filters now replaced by filter index (see Home.page)
    // filter: ['!'],
    icon: <IconMustSee />,
    index: 2,
    svg: `
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M11.1758 11.53C11.7223 10.763 11.6613 9.9553 11.2824 8.50235C10.533 5.62882 10.8314 4.05383 13.4147 2.18916L14.6756 1.27905L14.9806 2.80389C15.3047 4.42441 15.8369 5.42671 17.2036 7.35464C17.2579 7.43122 17.2579 7.43122 17.3124 7.50815C19.281 10.2854 20 11.9596 20 15C20 18.6884 16.2714 22 12 22C7.72841 22 4 18.6888 4 15C4 14.9311 4.00008 14.9331 3.98839 14.6285C3.89804 12.2718 4.33381 10.4274 6.09707 8.43586C6.46962 8.01509 6.89309 7.61068 7.36963 7.22371L8.42162 6.36946L8.92767 7.62658C9.30158 8.55547 9.7397 9.28567 10.2346 9.82151C10.6538 10.2754 10.9647 10.8461 11.1758 11.53ZM7.59449 9.76166C6.23712 11.2947 5.91441 12.6606 5.98692 14.5518C6.00042 14.9039 6 14.8915 6 15C6 17.5279 8.78361 20 12 20C15.2161 20 18 17.5275 18 15C18 12.4582 17.4317 11.135 15.6807 8.6647C15.6265 8.58818 15.6265 8.58818 15.5719 8.51125C14.5085 7.01111 13.8747 5.96759 13.4553 4.80052C12.7705 5.62118 12.8107 6.43739 13.2176 7.99766C13.967 10.8712 13.6686 12.4462 11.0853 14.3108L9.61228 15.3741L9.50185 13.5608C9.4313 12.4023 9.16907 11.6156 8.7654 11.1785C8.36657 10.7467 8.00647 10.2411 7.68356 9.66279C7.65343 9.69566 7.62375 9.72862 7.59449 9.76166Z" fill="url(#paint0_linear_1_1498)"/>
      <defs>
      <linearGradient id="paint0_linear_1_1498" x1="11.9886" y1="1.27905" x2="11.9886" y2="22" gradientUnits="userSpaceOnUse">
      <stop stop-color="#FFEBCE"/>
      <stop offset="1" stop-color="#FF9900"/>
      </linearGradient>
      </defs>
    </svg>
        `,
  },
]

export const CategoriesForMap = ({
  isExcursionBeingSelected,
  setExcursionBeingSelected,
}: {
  isExcursionBeingSelected: boolean
  setExcursionBeingSelected: (state: boolean) => void
}) => {
  const { selectedTags, isPayedClient, payedTours, selectedTab } = useAppSelector((store) => store.catalogStore)
  const dispatch = useAppDispatch()
  const location = useLocation()
  const navigate = useNavigate()
  const { t } = useTranslation('navigation')

  const handleCategoryChange = (tab: string) => {
    dispatch(setSelectedCategories(selectedTags))
    if (window.location.pathname !== '/') {
      setExcursionBeingSelected(false)
    }

    if (tab !== 'allPins' && tab !== 'mustSee' && tab !== 'top') {
      return window.scrollTo(0, 0)
    }
    dispatch(setSelectedTab({ type: tab }))
    window.scrollTo(0, 0)
  }

  const getCurrentFilter = () => selectedTags

  const [searchParams, setSearchParams] = useSearchParams()

  const postDataSubscription = async (refresh_token, user_id) => {
    console.log('Subscription request')
    console.log(process.env)
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WP_URL}/wp-json/wm-check/v1/user/tours`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add other headers if needed (like authorization)
          },
          body: JSON.stringify({
            RefreshToken: refresh_token,
            ID: user_id,
            token: process.env.REACT_APP_WP_TOKEN,
            // AccessToken: access_token,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log(result)
      if (result['success'] == '1' && result['active'] == '1') {
        console.log('Set payed subscription')
        dispatch(setPayed(true))
        // const tours = Object.keys(JSON.parse(result['result']))
        // console.log(JSON.parse(result['result']))
        // console.log(tours)
        // dispatch(setPayedTours(tours))
        // dispatch(setPayed(tours.length > 0))
        // console.log(payedTours)
      } else {
        dispatch(setPayed(false))
      }
    } catch (err) {
      console.log(err)
      dispatch(setPayed(false))
      // dispatch(setPayed(false))
    }
  }

  const postData = async (refresh_token, user_id) => {
    console.log('Tour access request')
    try {
      const response = await fetch(
        `${process.env.REACT_APP_WP_URL}/wp-json/wm-check/v1/user/tours`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            // Add other headers if needed (like authorization)
          },
          body: JSON.stringify({
            RefreshToken: refresh_token,
            ID: user_id,
            token: process.env.REACT_APP_WP_TOKEN,
          }),
        },
      )

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }

      const result = await response.json()
      console.log(result)
      if (result['success'] == '1' || result['result']) {
        console.log('Set payed')
        const tours = Object.keys(JSON.parse(result['result']))
        console.log(JSON.parse(result['result']))
        console.log(tours)
        dispatch(setPayedTours(tours))
        // dispatch(setPayed(tours.length > 0))
        console.log(payedTours)
      } else {
        dispatch(setPayedTours([]))
      }
    } catch (err) {
      console.log(err)
      dispatch(setPayedTours([]))
      // dispatch(setPayed(false))
    }
  }

  function getCookie(name) {
    const cookies = document.cookie.split('; ')
    for (const cookie of cookies) {
      const [cookieName, cookieValue] = cookie.split('=')
      if (cookieName === name) {
        return decodeURIComponent(cookieValue)
      }
    }
    return null
  }

  useEffect(() => {
    // Set payet if p=475089hfkdjfdjgfliureyg341f7hg4g13
    // console.log(searchParams.get('p'))
    // console.log(searchParams.get('p') == '475089hfkdjfdjgfliureyg341f7hg4g13')
    // if (searchParams.get('p') && searchParams.get('p') == '475089hfkdjfdjgfliureyg341f7hg4g13')
    //   dispatch(setPayed(true))
    const refresh_token = getCookie('WM_RefreshToken')
    const user_id = getCookie('WM_ID')
    // console.log(refresh_token, access_token)
    // if (refresh_token && access_token && !isPayedClient) {
    if (refresh_token && user_id) {
      // console.log(refresh_token)
      postData(refresh_token, user_id)
      postDataSubscription(refresh_token, user_id)
    }

    //If startExcursion in URL OR tour parameter exists then open excursion pop-up
    if (location.search.substring(1) === 'startExcursion' || searchParams.get('tour')) {
      // navigate('/map?startExcursion')
      navigate('/map?tour=' + searchParams.get('tour'))
      setExcursionBeingSelected(true)
    }
  }, [])

  return (
    <div className="categories">
      <div className="container">
        <div className="categories__carousel">
          <ul className="categories__carousel-list">
            {categoriesMap.map((item, index) => (
              <Link to="/map" key={index} onClick={() => handleCategoryChange(item.name)}>
                <li
                  className={`categories__carousel-item ${
                    selectedTab === item.name &&
                    !isExcursionBeingSelected &&
                    window.location.pathname !== '/'
                      ? 'active'
                      : ''
                  }`}
                >
                  <div
                    className="categories__carousel-locate"
                    // dangerouslySetInnerHTML={{ __html: item.svg }}
                  >
                    {item.icon}
                  </div>
                  <div className="categories__carousel-content">
                    <p>{t(item.name)}</p>
                  </div>
                </li>
              </Link>
            ))}
            {
              <li className="position-relative">
                <Link
                  onClick={() => {
                    if (window.location.pathname !== '/') {
                      setExcursionBeingSelected(true)
                      // modalSettings.open = false
                    } else {
                      window.scrollTo(0, 0)
                    }
                    const refresh_token = getCookie('WM_RefreshToken')
                    const access_token = getCookie('WM_AccessToken')
                    if (refresh_token && access_token) {
                      // console.log(refresh_token)
                      postData(refresh_token, access_token)
                    }
                  }}
                  to={'/map?startExcursion'}
                >
                  <div
                    className={`categories__carousel-item ${
                      isExcursionBeingSelected ? 'active' : ''
                    }`}
                  >
                    <div
                      className="categories__carousel-locate"
                      // dangerouslySetInnerHTML={{
                      //   __html: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      //           <path fill-rule="evenodd" clip-rule="evenodd" d="M6 22.0001C7.30622 22.0001 8.41746 21.1653 8.82929 20.0001H17.5C19.9853 20.0001 22 17.9854 22 15.5001C22 13.0148 19.9853 11.0001 17.5 11.0001H6.5C5.11929 11.0001 4 9.88079 4 8.50008C4 7.11936 5.11929 6.00008 6.5 6.00008H9.58579L8.29289 7.29297L9.70711 8.70718L13.4142 5.00008L9.70711 1.29297L8.29289 2.70718L9.58579 4.00008H6.5C4.01472 4.00008 2 6.01479 2 8.50008C2 10.9854 4.01472 13.0001 6.5 13.0001H17.5C18.8807 13.0001 20 14.1194 20 15.5001C20 16.8808 18.8807 18.0001 17.5 18.0001H8.82929C8.41746 16.8349 7.30622 16.0001 6 16.0001C4.34315 16.0001 3 17.3432 3 19.0001C3 20.6569 4.34315 22.0001 6 22.0001ZM5 19.0001C5 18.4478 5.44772 18.0001 6 18.0001C6.55228 18.0001 7 18.4478 7 19.0001C7 19.5524 6.55228 20.0001 6 20.0001C5.44772 20.0001 5 19.5524 5 19.0001ZM18 2.00008C19.6569 2.00008 21 3.34322 21 5.00008C21 6.65693 19.6569 8.00008 18 8.00008C16.3431 8.00008 15 6.65693 15 5.00008C15 3.34322 16.3431 2.00008 18 2.00008ZM17 5.00008C17 4.44779 17.4477 4.00008 18 4.00008C18.5523 4.00008 19 4.44779 19 5.00008C19 5.55236 18.5523 6.00008 18 6.00008C17.4477 6.00008 17 5.55236 17 5.00008Z" fill="url(#paint0_linear_1_1504)"/>
                      //           <defs>
                      //           <linearGradient id="paint0_linear_1_1504" x1="12" y1="1.29297" x2="12" y2="22.0001" gradientUnits="userSpaceOnUse">
                      //           <stop stop-color="#DCFFAF"/>
                      //           <stop offset="1" stop-color="#96DD3D"/>
                      //           </linearGradient>
                      //           </defs>
                      //           </svg>`,
                      // }}
                    >
                      <IconTours></IconTours>
                    </div>
                    <div className="categories__carousel-content">
                      <p data-test={window.location.href}>TOURS</p>
                    </div>
                  </div>
                </Link>
              </li>
            }
          </ul>
        </div>
      </div>
    </div>
  )
}
